export default "__VITE_ASSET__DiUcuJgF__"